import { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { EditLinkForm } from "./EditLinkForm";
import { initLinkService, Link } from "./linkService";

export default function EditLinkPage(props: RouteComponentProps) {
  const params = props.match.params as any;
  const [link, setLink] = useState<Link | null>(null);

  useEffect(() => {
    const linkService = initLinkService();
    if (params.linkId) {
      linkService.getLinkById(params.linkId)?.then(setLink);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.linkId]);

  return (
    <>
      {(!params.linkId || !!link) && <EditLinkForm link={link} />}
    </>
  );
}
